import { LoggedInUser, LoggedInUserConstructorArgs } from "@wexinc/wex-common-web";

export interface Idp {
  id: string;
  name: string;
}

export interface LoginInfo {
  identityProviderId: string | null;
}

export interface InvitationLoginMethods extends LoginMethods {
  email: string;
}

export interface InvitationAcceptance {
  inviteToken: string;
  firstName: string;
  lastName: string;
}

export interface InvitationAcceptanceWithSessionId extends InvitationAcceptance {
  oktaSessionId: string;
}

export interface CreateLocalInvitationUser {
  password: string;
  firstName: string;
  lastName: string;
}

export interface LoginMethods {
  usernameAndPasswordEnabled: boolean;
  identityProviders: Idp[];
}

export interface WexTokens {
  accessToken: string;
}

export class COPLoggedInUser extends LoggedInUser {
  constructor(args: LoggedInUserConstructorArgs) {
    super(args);
  }
}

export interface Role {
  allowGlobal: boolean;
  allowInOrg: boolean;
  description: string;
  id: string;
  name: string;
  globalPermissionRequiredToEdit?: string;
  orgPermissionRequiredToEdit?: string;
}

export const knownRoles = {
  orgMember: "Org Member",
  orgOwner: "Org Owner",
};

export type CopPermissionIds = keyof typeof CopPermissions;

export const CopPermissions = {
  createOrganization: "Create Organization",
  editOrganization: "Edit Organization",
  deleteOrganization: "Delete Organization",
  editMembers: "Edit Members",
  editRoles: "Edit Roles",
  editOrgOwner: "Edit Org Owner",
  editAccountManager: "Edit Account Manager",
  editSupport: "Edit Support",
  editAdmin: "Edit Admin",
};

export interface PasswordRequestInfo {
  email: string;
}
